import { useCallback, useMemo, useState } from "react";

import type {
  DialogControlContextType,
  DialogDataContextType,
} from "../context";
import type { DialogContent } from "../types";

export const useDialogStore = (): {
  control: DialogControlContextType;
  data: DialogDataContextType;
} => {
  const [isOpened, setIsOpened] = useState(false);
  const [dialogContent, setDialogContent] = useState<DialogContent | null>(
    null,
  );
  const [onClose, setOnClose] = useState<(() => void) | undefined>(undefined);

  const openDialog = (content: DialogContent, onDialogClose?: () => void) => {
    setDialogContent(content);
    setIsOpened(true);
    if (onDialogClose) {
      setOnClose(() => onDialogClose);
    }
  };

  const closeDialog = useCallback(() => {
    setIsOpened(false);
    setDialogContent(null);
    onClose?.();
    setOnClose(undefined);
  }, [onClose]);

  return {
    control: useMemo(() => ({ closeDialog, openDialog }), [closeDialog]),
    data: useMemo(
      () => ({ dialogContent, isOpened, onClose }),
      [isOpened, dialogContent, onClose],
    ),
  };
};
